import React, { useEffect } from 'react'
import { useState } from 'react'
import { Button, Card, Carousel, Col, Input, Row } from 'reactstrap'
import GetBrandProfileListService from '../../../../../../../../../Service/DashboardServices/QuestionnaireServices/GetBrandProfileListService';
import { connect } from 'react-redux';
import GetFileListByCategoryService from '../../../../../../../../../Service/DashboardServices/AssetGalleryServices/GetFileListByCategoryService';
import BackButton from "../../../../.././../../../../designUtils/Logo/BackButton.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTimes, faAngleDown, faAngleUp, faCloudUploadAlt, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import RenameFileAssetNewService from '../../../../../../../../../Service/DashboardServices/AssetGalleryServices/RenameFileAssetNewService';
import TickMark from '../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/TickMark.svg'
import Rename from '../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Rename.svg'
import Download from '../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Download.svg'
import Close from '../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Close.svg'
import CustomModal from '../../../../../../../../Components/Modals/CustomModal';
import GetFileListBySubCategoryService from '../../../../../../../../../Service/DashboardServices/AssetGalleryServices/GetFileListBySubCategoryService';
import ImageAndLogo from './Components/Brand/ImageAndLogo';
// import UploadBrandImages from './SubComponents/UploadBrandImages';
import UploadAllTypeOfAssetsFile from './Components/UploadAllTypeOfAssetsFile';
import UploadImagesAndOriginalFiles from './Components/UploadImagesAndOriginalFiles';
import LoadingOverlay from 'react-loading-overlay';
import Loader from "react-loaders";
import OtherBrandAsset from './Components/Brand/OtherBrandAsset';
import FetchAllCategoryAndSubCategory from '../../../../../../../../../Service/DashboardServices/AssetGalleryServices/FetchAllCategoryAndSubCategoryService';
import UploadVideosPage from './Components/Brand/UploadVideosPage';
import VideosForBrand from './Components/Brand/VideosForBrand';
import CreateBrandProfileMainPage from '../../Questionnaire/CreateBrandProfileMainPage';

function BrandDetails(props) {
    const [subCategoryId, setSubCategoryId] = useState()
    const [brandProfile, setBrandProfile] = useState();
    const [fileListOfAssets, setFileListOfAssets] = useState([]);
    const [allFileListOfAssets, setAllFileListOfAssets] = useState([]);
    const [brand, setBrand] = useState();
    const [isInfoTabOpen, setIsInfoTabOpen] = useState(false)
    const [uploadImagesPage, setUploadImagesPage] = useState(false)
    const [subCategoryText, setSubCategoryText] = useState()
    const [loadScreen, setLoadScreen] = useState(false)
    const [changeTabs,setChangeTabs]=useState(false)
    const [defaultSubCatid, setdefaultSubCatid] = useState();
    const [fileListOfAssetsVideo, setFileListOfAssetsVideo] = useState(false);
    const [subCategory,setSubCategory]= useState()
    const [GraphicsSubCatList, setGraphicsSubCatList] = useState();
    const [documentSubCategoryList, setDocumentSubCategoryList] = useState();
    
    useEffect(() => {
        let data = {
            integerId: props.storeOverview.integerID,
            assetIdentifier:brand?brand.brandName:''
          };
       
        GetBrandProfileListService(props.token, data).then((response) => {
            if (response) {
                setBrandProfile(response.brandList);
                console.log(response);
                onloadBrandFun()
            }
        });
        // 
    }, []);
const onloadBrandFun =()=>{
    let data = {
        integerId: props.storeOverview.integerID,
        assetIdentifier:brand?brand.brandName:''
      };
      console.log(data);
    FetchAllCategoryAndSubCategory(props.token,data).then((response) => {
    if (response) {
        console.log(response)
        const filteredSubCategories = response.subCategory && response.subCategory.filter((subCat) => subCat.assetCategory === props.catId);
        console.log('filteredSubCategories');
        console.log(filteredSubCategories);
        if(filteredSubCategories.length > 0)
        {
            setdefaultSubCatid(filteredSubCategories[0].id)
            setSubCategoryText(filteredSubCategories[0].subCategoryName)
            setSubCategoryId(filteredSubCategories[0].id)
        }         
        }})
}
    const GetFileListBySubCategory = (id,bname) => {
        setdefaultSubCatid(id)
      setLoadScreen(true)
        let data = {
            integerId: props.storeOverview.integerID,
            assetCategory:props.catId,
            subCategoryId: id ? id : '',
            assetIdentifier:bname?bname:''
        };
        GetFileListBySubCategoryService(props.token, data).then((response) => {
            if (response) {
                const imageFiles = response.fileList.filter(file => {
                    const extension = file.fileName.toLowerCase().split('.').pop();
                    return ['jpg', 'png', 'jpeg'].includes(extension);
                });
                const videoFiles = response.fileList.filter(file => {
                    const extension = file.fileName.toLowerCase().split('.').pop();
                    return ['mp4', 'mov', 'avi', 'mkv'].includes(extension);
                });
                console.log(response)
                setFileListOfAssets(imageFiles);
                setFileListOfAssetsVideo(videoFiles)    
                setAllFileListOfAssets(response.fileList)
                const filteredGraphicsSubCatList = response.GraphicsSubCatList && response.GraphicsSubCatList.filter(
                    (cat) => cat.assetCategory__categoryName === "Brand"
                  );
                const filteredDocumentSubCatList = response.documentSubCategoryList && response.documentSubCategoryList.filter(
                    (cat) => cat.assetCategory__categoryName === "Brand"
                  );
                  setGraphicsSubCatList(filteredGraphicsSubCatList);
                setDocumentSubCategoryList(filteredDocumentSubCatList)

                console.log(response.fileList);
                setLoadScreen(false)
            }
        });
    }

    const handleBackbutton = () => {
        setSubCategoryId(defaultSubCatid)
    }
    const setBrandInfo = (brandId) => {
        // onloadBrandFun()
        const brandInfo =  brandProfile && brandProfile.filter((brand) => brand.id == brandId)
        console.log(brandInfo)
        setBrand(brandInfo[0])
        let data = {
            integerId: props.storeOverview.integerID,
            assetIdentifier:brandInfo[0]?brandInfo[0].brandName:''
          };
          console.log(data);
        FetchAllCategoryAndSubCategory(props.token,data).then((response) => {
        if (response) {
            console.log(response)
            const filteredSubCategories = response.subCategory && response.subCategory.filter((subCat) => subCat.assetCategory === props.catId);
            console.log('filteredSubCategories');
            console.log(filteredSubCategories);
            setSubCategory(filteredSubCategories)
            if(filteredSubCategories.length > 0)
            {
                setdefaultSubCatid(filteredSubCategories[0].id)
                setSubCategoryText(filteredSubCategories[0].subCategoryName)
                setSubCategoryId(filteredSubCategories[0].id)
            }         
            }})
    
        GetFileListBySubCategory(defaultSubCatid,brandInfo[0].brandName)
    }
    const handleUploadAssetsUi = () => {
        setUploadImagesPage(true);
        setIsInfoTabOpen(false);
    }
    const handleBackFromUploadAssets = (file, flag) => {
        console.log(file)
        if(flag ===2){
        console.log(file.fileList)
            setAllFileListOfAssets(file.fileList)
        }
        setUploadImagesPage(false);

    }
    const handleBackFromUploadAssetsImages=()=>{
        setUploadImagesPage(false)
       }
    const handleSubCategory = (tab) => {
        console.log(tab)
        setSubCategoryId(tab.id);
        setIsInfoTabOpen(false);
        setSubCategoryText(tab.subCategoryName)
        // GetFileListBySubCategory(tab.id)
    }
    const renderUploadAssetsPage = () => {
        if (subCategoryText == 'Images' || subCategoryText == 'Logo') {
            return (
                <><UploadImagesAndOriginalFiles
                    setSubCategory={setSubCategory}
                    defaultSubCatid={defaultSubCatid}
                    subCategory={subCategory}
                    action={false}
                    subCategoryId={subCategoryId}
                    handleBackFromUploadAssetsImages={handleBackFromUploadAssetsImages}
                    assetIdentifier={brand.brandName} 
                    setFileListOfAssets={setFileListOfAssets}
                    assetCategory = {props.catId} /></>
            )
        }
        else if(subCategoryText == 'Videos'){
            return(
                <UploadVideosPage
                subCategory={subCategory}
                defaultSubCatid={defaultSubCatid}
                action={false}
                setSubCategory={setSubCategory}
                subCategoryId={subCategoryId}
                handleBackFromUploadAssetsImages={handleBackFromUploadAssetsImages}
                assetIdentifier={brand.brandName} 
                setFileListOfAssetsVideo={setFileListOfAssetsVideo}
                assetCategory = {props.catId}

                />
            )
        }

        else {
            return (
                <> <UploadAllTypeOfAssetsFile
                    action={false}
                    defaultSubCatid={defaultSubCatid}
                    subCategory={subCategory}
                    setSubCategory={setSubCategory}
                    subCategoryId={subCategoryId}
                    handleBackFromUploadAssets={handleBackFromUploadAssets}
                    flagNumber={20}
                    assetIdentifier={brand.brandName} 
                    setFileListOfAssets={setFileListOfAssets}
                    assetCategory = {props.catId}/>
                    
                    </>
            )
        }

    }
    const handleOpenFileInfo = () => {
        setIsInfoTabOpen(!isInfoTabOpen)   
    }
    return (
        <>
            {uploadImagesPage ? renderUploadAssetsPage() :
                <Row>
                    {!brand ?
                        <Col>
                            <Card className='p-2 child-card '>
                                <h6><b>Choose your brand</b></h6>
                                <select
                                    className="form-control w-25 mb-3"
                                    onChange={(e) => { setBrandInfo(e.target.value) }}
                                >
                                    <option >--Select Brand --</option>
                                    {brandProfile && brandProfile.map((brand) => (
                                        <option
                                            key={brand.id}
                                            value={brand.id}>{brand.brandName}</option>
                                    ))}
                                </select>
                            </Card>
                        </Col>
                        :
                        <>
                            <Col md={12}>
                                <Card className='p-2 mb-3 child-card' >
                                    <Row>
                                        <Col md={12}>
                                            <div className='d-flex justify-content-between'>
                                                <div className='d-flex '>
                                                    <button onClick={() => { handleBackbutton(); setBrand();setIsInfoTabOpen(false);setSubCategoryText('Images') }} className="hover-btn-link back-btn ml-2 mb-3 mr-1 "  >
                                                        <img src={BackButton} alt="not found" />
                                                    </button>
                                                    <h5 className=''><b>{brand.brandName}</b></h5>
                                                </div>
                                                {subCategoryId && props.UserPermission.AssetGallery_UploadBrandAssets  && 
                                                    (
                                                        <Button
                                                            onClick={() => handleUploadAssetsUi()}
                                                            className='btn-background-color-Proceed-gallery  ml-2'
                                                            disabled={!brand}
                                                        >
                                                            Upload Assets
                                                        </Button>
                                                    )}
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className='d-flex mt-1'>
                                                {subCategory && subCategory.map((sub) =>
                                                (<>
                                                    {sub.assetCategory == props.catId ?
                                                        <p className={`mb-0 d-flex ${sub.id === subCategoryId ? 'selected-tab-assets-tab ' : 'assets-tab-not-selected'}`}
                                                            onClick={() => { handleSubCategory(sub); GetFileListBySubCategory(sub.id,brand.brandName); setChangeTabs(true) }}
                                                        >
                                                            <b>{sub.subCategoryName}</b>
                                                            {sub.count!=0?
                                                            <span className="assets-category-count">
                                                            {sub.count} </span>:""}
                                                            {/* <p className='Assets-Counts mb-0'>{sub.count}</p> */}
                                                        </p>
                                                        : ''
                                                    }</>)
                                                )
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col md={12}>
                            <LoadingOverlay
                              active={loadScreen}
                              styles={{
                                overlay: (base) => ({
                                  ...base,
                                  background: '#f1f4f6',
                                  opacity: 1,
                                }),
                                content: (base) => ({
                                  ...base,
                                  color: '#000',
                                }),
                              }}
                              spinner={<Loader active type="ball-pulse" />}
                              text="Loading asset details..."
                            >
                           
                                {subCategoryId < 3 ?<ImageAndLogo //Logo ,Images
                                    changeTabs={changeTabs}
                                    defaultSubCatid={defaultSubCatid}
                                    action={false}
                                    subCategory={subCategory}
                                    GraphicsSubCatList={GraphicsSubCatList}
                                    setGraphicsSubCatList={setGraphicsSubCatList}
                                    brand={brand}
                                    setSubCategory={setSubCategory}
                                    handleOpenFileInfo={handleOpenFileInfo}
                                    isInfoTabOpen={isInfoTabOpen}
                                    setIsInfoTabOpen={setIsInfoTabOpen}
                                    subCategoryId={subCategoryId} 
                                    fileListOfAssets={fileListOfAssets} 
                                    setFileListOfAssets={setFileListOfAssets}
                                    assetCategory={props.catId}
                                    />

                                :subCategoryId === 13? //Videos
                                <VideosForBrand
                                setSubCategory={setSubCategory}
                                defaultSubCatid={defaultSubCatid}
                                action={false}
                                subCategory={subCategory}
                                assetIdentifier={brand?brand.brandName:''}
                                changeTabs={changeTabs}
                                brand={brand}
                                fileListOfAssetsVideo={fileListOfAssetsVideo}
                                setFileListOfAssetsVideo={setFileListOfAssetsVideo}
                                handleOpenFileInfo={handleOpenFileInfo}
                                isInfoTabOpen={isInfoTabOpen}
                                setIsInfoTabOpen={setIsInfoTabOpen}
                                subCategoryId={subCategoryId} 
                                fileListOfAssets={fileListOfAssetsVideo}
                                setFileListOfAssets={setFileListOfAssets}
                                assetCategory={props.catId}
                                />
                                :subCategoryId === 18? 
                                <CreateBrandProfileMainPage
                                catId={1}
                                categoryID={1}
                                brand={brand}
                                />:

                                 <OtherBrandAsset
                                action={false}
                                subCategory={subCategory}
                                defaultSubCatid={defaultSubCatid}
                                setSubCategory={setSubCategory}
                                refreshAssets={() =>
                                    GetFileListBySubCategory(subCategoryId, brand.brandName)
                                  }
                                 changeTabs={changeTabs}
                                 allFileListOfAssets={allFileListOfAssets}
                                 brand={brand}
                                 setDocumentSubCategoryList={setDocumentSubCategoryList}
                                 documentSubCategoryList={documentSubCategoryList}
                                 subCategoryId={subCategoryId} 
                                 fileListOfAssets={fileListOfAssets} 
                                 setAllFileListOfAssets={setAllFileListOfAssets}
                                 setFileListOfAssets={setFileListOfAssets}
                                 assetCategory={props.catId}/>
                                 }
                            </LoadingOverlay>
                            </Col>
                        </>
                    }
                </Row>}
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        token: state.loggedUser.token,
        accessLevel: state.loggedUser.accessLevel,
        UserPermission: state.accountOverview.store.StoreUserPermission,
        storeOverview: state.accountOverview.store.storeOverview,
    };
};

export default connect(mapStateToProps)(BrandDetails)